import React, { useEffect } from 'react';
import { login } from '@/config/auth';

/**
 * Redireciona o usuário não autenticado para o login do Keycloak via OAuth2.
 * Exibe um loading enquanto o redirecionamento é aplicado.
 */
export const RedirectToKeycloakLogin = () => {
  useEffect(() => {
    login();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary" />
    </div>
  );
};
